import request from '@/utils/request'

// 链接库列表
export const cozeAuth = (params?: any): Promise<any> => {
    return request.post('/web/oauth2/coze', params)
}
